/* Errorhandling
 * depends on stacktrace.js
 * @version 1.3
 * @date 10-02-2015
 */


// Avoid `console` errors in browsers that lack a console.
(function() {
	var method;
	var noop = function () {};
	var methods = [
		'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = (window.console = window.console || {});

	while (length--) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
}());

$(document).ajaxError(function(e, xhr, settings, exception) {
	// no exception, no error (refreshed?)
	if (!exception) return;

	// create an error object
	var data = {
		error : 'ajaxError',
		exception : ''+exception,
		url : settings.url,
		data : settings.data,
		statusText : xhr.statusText,
		responseText : xhr.responseText
	}

	try {
		if (xhr && xhr.responseJSON && xhr.responseJSON.content) {
			var text = xhr.responseJSON.content;
		} else {
			var text = xhr.responseText;
		}
		if (text) bootbox.alert(text);
	} catch (e) {errorcallback(e);}


	if (typeof console == 'object') {
		console.log('Oops, we got an ajax exception');
		console.log(data);
	}
});


window.onerror = function(msg, url, line) {
	//senderror({msg:msg,url:url,line:line});

	if (typeof console == 'object') {
		console.log('Oops, we got a uncatched javascript exception');
		console.log(msg);
		console.log('url: '+url);
		console.log('line: '+line);
	}

	return true;
}

function errorcallback(e) {
	var data = printStackTrace({e: e});
	senderror(data);
	return true;
}

function senderror(data) {
	if (typeof console == 'object') {
		console.log('Oops, we got a javascript exception');
		console.log(data);
	}

	$.ajax({
		type: 'POST',
		url: '/ajax.php',
		data: {url:'jserror',data:data},
		dataType: 'json',
		cache:false,
		global: false // disable the ajaxStart / ajaxStop
	});
}